import { ArrowForward } from '@material-ui/icons'
import { Link } from 'gatsby'
import React, { type FC } from 'react'
import styled from 'styled-components'

import { getLinkTarget, getValidUrl } from '../../helpers/url'
import theme from './theme'

const { colours, icon, animation } = theme

type ArrowLinkTypes = {
  children: React.ReactNode
  to: string
}

const ArrowForwardStyled = styled(ArrowForward)`
  vertical-align: middle;
  margin-left: 1rem;

  &.MuiSvgIcon-root {
    width: ${icon.smallSize};
    height: ${icon.smallSize};
    vertical-align: text-bottom;
  }
`

const Styles = `
  color: ${colours.primary};
  text-decoration: none;
  position: relative;
  margin-bottom: 0.8rem;
  
  &::after {
      content: '';
      width: 0;
      height: 100%;
      display: block;
      position: absolute;
      bottom: -0.3rem;
      left: 50%;
      border-bottom: 0.2rem solid ${colours.primary};
      transition: left ${animation.defaultLength} ease-in-out,
        width ${animation.defaultLength} ease-in-out;
    }
  &:hover {
    &::after {
      content: '';
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      bottom: -0.3rem;
      left: 0;
      border-bottom: 0.2rem solid ${colours.primary};
    }
  }
`

const StyledLink = styled(Link)`
  ${Styles}
`

const StyledNonLink = styled.span`
  ${Styles}
`

const ArrowLink: FC<ArrowLinkTypes> = (props) => {
  const { children, ...rest } = props

  const link = getValidUrl(props.to)

  const internal = /^\/(?!\/)/.test(link)

  if (link) {
    if (internal) {
      return (
        <StyledLink {...rest}>
          {children}
          <ArrowForwardStyled />
        </StyledLink>
      )
    }

    return (
      <StyledLink href={link} as='a' target={getLinkTarget(link)}>
        {children}
        <ArrowForwardStyled />
      </StyledLink>
    )
  }

  return (
    <StyledNonLink {...rest}>
      {children}
      <ArrowForwardStyled />
    </StyledNonLink>
  )
}

export default ArrowLink
